import {
  BrowserRouter,
  Routes,
  Route,
  useLocation,
  Navigate,
  Outlet,
} from 'react-router-dom';
import { MantineProvider, AppShell } from '@mantine/core';
import { theme } from './theme';
import LandingPage from '../pages/LandingPage/LandingPage';
import Blog from '../pages/Blog/Blog';
import BlogPost from '../pages/Blog/BlogPost';
import About from '../pages/About/About';
import Terms from '../pages/Terms/Terms';
import { IntakeFormPage } from '../pages/IntakeForm/IntakeFormPage';
import PublicHeader from '../components/PublicHeader/PublicHeader';
import ScrollToTop from '../components/ScrollToTop/ScrollToTop';
import { SECTION_PATH_TO_ID } from '../pages/LandingPage/sectionPaths';
import LandingGradientBackground from '@practist/components/LandingGradientBackground/LandingGradientBackground';

function MarketingLayout() {
  const location = useLocation();
  const isLandingPage =
    location.pathname === '/' || location.pathname in SECTION_PATH_TO_ID;

  const shell = (
    <AppShell
      header={{ height: 80 }}
      padding={0}
      styles={() => ({
        header: {
          backgroundColor: isLandingPage ? 'transparent' : 'black',
        },
      })}
    >
      <AppShell.Header>
        <PublicHeader />
      </AppShell.Header>
      <AppShell.Main>
        <ScrollToTop />
        <Outlet />
      </AppShell.Main>
    </AppShell>
  );

  if (isLandingPage) {
    return <LandingGradientBackground>{shell}</LandingGradientBackground>;
  }

  return shell;
}

function App() {
  return (
    <MantineProvider theme={theme} defaultColorScheme='auto'>
      <BrowserRouter>
        <Routes>
          <Route path='/forms/:firmId/:formId' element={<IntakeFormPage />} />
          <Route element={<MarketingLayout />}>
            <Route path='/' element={<LandingPage />} />
            {Object.keys(SECTION_PATH_TO_ID).map((path) => (
              <Route key={path} path={path} element={<LandingPage />} />
            ))}
            <Route path='/resources' element={<Blog />} />
            <Route path='/resources/:id' element={<BlogPost />} />
            <Route path='/blog' element={<Blog />} />
            <Route path='/blog/:id' element={<BlogPost />} />
            <Route path='/about' element={<About />} />
            <Route
              path='/signup/complete'
              element={<Navigate to='/' replace />}
            />
            <Route path='/signup' element={<Navigate to='/' replace />} />
            <Route path='/terms' element={<Terms />} />
            <Route path='/privacy' element={<Navigate to='/terms' replace />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </MantineProvider>
  );
}

export default App;
